export default __webpack_public_path__ + "static/media/Trash.92c066c5.svg";